import { defineStore } from "pinia";
import { useConfidentialLoggingSetup } from "./confidentialLogging";

export const useLogsStore = defineStore("logs", () => {
  const confidentialLogging = useConfidentialLoggingSetup();

  return {
    ...confidentialLogging
  };
});
